export const USER_BUDGET_TEMPLATES_FOLDER_NAME = 'User Budget Templates';
export const BUILT_IN_TEMPLATE_KIND = 'built-in-template';
export const USER_TEMPLATE_KIND = 'user-template';

const toOptionValue = value =>
  value === null || value === undefined ? '' : value.toString();

export const getUserBudgetTemplates = (budgets, ownerEmail) =>
  (budgets || [])
    .filter(
      budget =>
        budget?.is_user_template &&
        (!ownerEmail || budget?.created_by_email === ownerEmail)
    )
    .sort((first, second) =>
      (first?.name || '').localeCompare(second?.name || '', undefined, {
        sensitivity: 'base',
      })
    );

export const buildBudgetTemplateOptions = (budgetTypes, userTemplates) => {
  const builtInOptions = [
    {
      label: 'Blank Budget (No Template)',
      value: '',
      templateKind: BUILT_IN_TEMPLATE_KIND,
    },
    ...((budgetTypes || []).map(template => ({
      label: template?.name,
      value: toOptionValue(template?.id),
      templateKind: BUILT_IN_TEMPLATE_KIND,
    })) || []),
  ];

  const options = [
    {
      label: 'Built-in Templates',
      options: builtInOptions,
    },
  ];

  if (userTemplates?.length) {
    options.push({
      label: 'User Templates',
      options: userTemplates.map(template => ({
        label: template?.name,
        value: `user-template-${template?.id}`,
        templateKind: USER_TEMPLATE_KIND,
        budget_id: template?.id,
      })),
    });
  }

  return options;
};

export const isUserTemplateOption = option =>
  option?.templateKind === USER_TEMPLATE_KIND;
